export enum FeaturesEnum {
  MassReplace = 'massReplace',
  PricingAdmin = 'pricingAdmin',
  ManageDocumentTemplate = 'manageDocumentTemplate',
  ManageEmailTemplate = 'manageEmailTemplate',
  RecentPacks = 'recentPacks',
  InAppNotifications = 'inAppNotifications',
  IrisStatus = 'irisStatus',
  RevisionExport = 'revisionExport',
  PackGrouping = 'packGrouping',
}
